import React from 'react';
// import { authRoles } from '../../auth/authRoles';

const menuRoutes = [
	{
		path: '/ranking-order',
		component: React.lazy(() => import('./RankingOrder')),
	},
	{
		path: '/dept-abc',
		component: React.lazy(() => import('./DeptAbc')),
	},
	{
		path: '/abc',
		component: React.lazy(() => import('./Abc')),
	},
	{
		path: '/ranking-menu',
		component: React.lazy(() => import('./RankingMenu')),
	},
	{
		path: '/menu-ratio',
		component: React.lazy(() => import('./MenuRatio')),
	},
];

export default menuRoutes;
